import { Observable } from 'rxjs';
import { Position, DataSourceResponse} from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';


@Injectable({ providedIn: 'root' })
export class PositionService extends ApiService {
  endPoint = '/api/positions';
  create(model: Position) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: Position) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<Position> {
    return this.http.get<Position>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<Position>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }
}
